import { render } from "./ManageLearningCourseContent.vue?vue&type=template&id=506a1014&lang=pug"
import script from "./ManageLearningCourseContent.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourseContent.vue?vue&type=script&lang=js"

import "./ManageLearningCourseContent.vue?vue&type=style&index=0&id=506a1014&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__